export const MicIcon = (props) => {
  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.17684 7.97815C7.31439 7.97815 8.23576 7.05678 8.23576 5.91923V3.08822C8.23576 1.95066 7.31439 1.0293 6.17684 1.0293C5.03929 1.0293 4.11792 1.95066 4.11792 3.08822V5.91923C4.11792 7.05678 5.03929 7.97815 6.17684 7.97815Z"
        stroke={props?.color ?? "white"}
        strokeWidth={0.772095}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.23901 4.96777V5.84281C2.23901 8.01497 4.00454 9.7805 6.1767 9.7805C8.34886 9.7805 10.1144 8.01497 10.1144 5.84281V4.96777"
        stroke={props?.color ?? "white"}
        strokeWidth={0.772095}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.46118 3.30904C5.92444 3.13918 6.42887 3.13918 6.89213 3.30904"
        stroke={props?.color ?? "white"}
        strokeWidth={0.772095}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.76514 4.40073C6.03794 4.32866 6.32105 4.32866 6.59385 4.40073"
        stroke={props?.color ?? "white"}
        strokeWidth={0.772095}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.17676 9.78027V11.3245"
        stroke={props?.color ?? "white"}
        strokeWidth={0.772095}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
